"use client";

import { useMemo } from "react";
import { benefits } from "./data";
import { useComponentTranslations } from "@/app/components/LanguageProvider";
import BenefitCard from "./BenefitCard";

export default function WhyDev48Mobile() {
  const { t } = useComponentTranslations("WhyDev48");

  const translatedBenefits = useMemo(
    () =>
      benefits.map((b) => ({
        ...b,
        title: t(b.titleKey as Parameters<typeof t>[0]) ?? b.titleKey,
        text: t(b.descKey as Parameters<typeof t>[0]) ?? b.descKey,
      })),
    [t]
  );

  return (
    <section className="relative overflow-x-hidden py-9">
      <div className="w-full max-w-7xl mx-auto px-4 lg:px-6 relative z-10">
        <div className="text-center">
          <h2 className="text-3xl font-bold tracking-tight text-white/95">
            {t("sectionTitle" as Parameters<typeof t>[0])}
          </h2>
          <p className="mt-3 text-sm text-white/70 max-w-2xl mx-auto pb-9">
            {t("sectionSubtitle" as Parameters<typeof t>[0])}
          </p>
        </div>

        <div className="grid grid-cols-2 gap-2.5">
          {translatedBenefits.map((item, i) => (
            <BenefitCard key={item.id} item={item} index={i} compact />
          ))}
        </div>
      </div>
    </section>
  );
}